// Delete dialogs ask the user to retype a record's name. The name is shown as
// HTML text, which collapses runs of whitespace, so a name stored with a double
// space (common in names imported from Optro) or a trailing space can never be
// typed back exactly as it reads. Both sides are compared the way the prompt
// displays them: trimmed, each whitespace run collapsed to one space, and case
// ignored.

export function normalizeConfirmationText(value: string): string {
  return value.trim().replace(/\s+/g, " ").toLowerCase();
}

export function matchesConfirmationText(
  typed: string,
  expected: string,
): boolean {
  return (
    normalizeConfirmationText(typed) === normalizeConfirmationText(expected)
  );
}
